import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import regeneratorRuntime from "/opt/app/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useContext, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { animateScroll as scroll } from "react-scroll";
import { LoadingOverlay, MainPage } from "styles/jss/Layout.styles";
import { ProposalFormPage } from "styles/jss/FormPages.styles";
import { Container, Grid } from "@mui/material";
import { PageContainer } from "components/PagesComponents";
import { Step1, Step2 } from "components/PagesComponents/ProposalForm";
import { FormSuccess, Loader, Redirect } from "components";
import Stepper from "components/Stepper";
import { postForm } from "services/forms.api";
import { RecaptchaContext } from "Hook/recaptchaContext";
var STEPS = [
    {
        id: 1,
        title: "اطلاعات پیشنهاد"
    },
    {
        id: 2,
        title: "اطلاعات پیشنهاد دهنده"
    }
];
function ProposalForm() {
    var t = useTranslation([
        "form"
    ]).t;
    var locale = useRouter().locale;
    var ref = useState(1), step = ref[0], setStep = ref[1];
    var ref1 = useState({}), stepFormData = ref1[0], setStepFormData = ref1[1];
    var ref2 = useState(null), successKey = ref2[0], setSuccessKey = ref2[1];
    var ref3 = useMutation(function(data) {
        return postForm(data, "/form-proposals");
    }, {
        onError: function(error) {
            var ref;
            // An error happened!
            if (!!Object.keys(error.response.data.error.details).length) {
                var ref1;
                var keys = Object.keys(error.response.data.error.details);
                var msgError = keys.join(" , ");
                return toast.error("".concat((ref1 = error.response.data.error.message) === null || ref1 === void 0 ? void 0 : ref1.toString(), " ").concat(msgError));
            }
            toast.error((ref = error.response.data.error.message) === null || ref === void 0 ? void 0 : ref.toString());
        },
        onSuccess: function(param) {
            var data = param.data;
            setSuccessKey(data.attributes.tracking_code);
            // Boom baby!
            toast.success(t("success-toast"));
        }
    }), mutate = ref3.mutate, isLoading = ref3.isLoading;
    var ref4 = useContext(RecaptchaContext), loading = ref4.loading, handleRecaptcha = ref4.handleRecaptcha;
    var handle_formsData = function() {
        var _ref = _async_to_generator(regeneratorRuntime.mark(function _callee(data) {
            var body, keys, files, formData, i, captchaRes;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setStepFormData(data);
                        body = _object_spread_props(_object_spread({}, data), {
                            context_proposal: data.context_proposal.join(", ").toString()
                        });
                        keys = Object.keys(body);
                        files = keys.filter(function(key) {
                            return key.includes("attachment");
                        }).map(function(keyFile) {
                            return body[keyFile];
                        });
                        keys.map(function(item) {
                            return item.includes("attachment") && delete body[item];
                        });
                        formData = new FormData();
                        for(i = 0; i < files.length; i++){
                            if (!!files[i].length) {
                                formData.append("files.attachment_".concat(i + 1), files[i][0], files[i][0].name);
                            }
                        }
                        formData.append("data", JSON.stringify(body));
                        if (!(step === 2)) {
                            _ctx.next = 16;
                            break;
                        }
                        _ctx.next = 11;
                        return handleRecaptcha();
                    case 11:
                        captchaRes = _ctx.sent;
                        if (!(captchaRes.status !== "success")) {
                            _ctx.next = 14;
                            break;
                        }
                        return _ctx.abrupt("return", null);
                    case 14:
                        mutate(formData);
                        return _ctx.abrupt("return");
                    case 16:
                        scroll.scrollTo(250);
                        setStep(function(prev) {
                            return prev + 1;
                        });
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handle_formsData(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var handle_prevStep = function() {
        scroll.scrollTo(250);
        setStep(function(prev) {
            return prev - 1;
        });
    };
    if (locale === "en") {
        return /*#__PURE__*/ _jsx(Redirect, {});
    }
    var handle_formStepRender = function() {
        switch(step){
            case 1:
                return /*#__PURE__*/ _jsx(Step1, {
                    defaultFormValue: stepFormData,
                    setDataForm: handle_formsData
                });
            case 2:
                return /*#__PURE__*/ _jsx(Step2, {
                    defaultFormValue: stepFormData,
                    setDataForm: handle_formsData,
                    prevStep: handle_prevStep
                });
        }
    };
    return /*#__PURE__*/ _jsx(PageContainer, {
        title: "فرم ارائه پیشنهاد",
        children: /*#__PURE__*/ _jsx(MainPage, {
            children: /*#__PURE__*/ _jsx(ProposalFormPage, {
                children: /*#__PURE__*/ _jsx(Container, {
                    children: /*#__PURE__*/ _jsxs(Grid, {
                        container: true,
                        columnSpacing: {
                            md: 3
                        },
                        rowSpacing: {
                            xs: 3,
                            md: 0
                        },
                        sx: {
                            position: "relative"
                        },
                        children: [
                            loading || isLoading ? /*#__PURE__*/ _jsx(LoadingOverlay, {
                                children: /*#__PURE__*/ _jsx(Loader, {})
                            }) : "",
                            !!successKey ? /*#__PURE__*/ _jsx(Grid, {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ _jsx(FormSuccess, {
                                    successKey: successKey
                                })
                            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(Grid, {
                                        item: true,
                                        xs: 12,
                                        md: 4,
                                        className: "borderRight",
                                        children: /*#__PURE__*/ _jsx(Stepper, {
                                            steps: STEPS,
                                            active: step
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Grid, {
                                        item: true,
                                        xs: 12,
                                        md: 8,
                                        children: handle_formStepRender()
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
}
export var __N_SSG = true;
export default _withSuperJSONPage(ProposalForm);
